// Error messages
export const ERROR_MESSAGES = {
    NETWORK_CONNECTION_ERROR: "Network connection error",
    CONNECTION_ERROR_TITLE: "CONNECTION ERROR",
    CONNECTION_ERROR_MESSAGE: "Please check your network connectivity and try again",
} as const;

// HTTP status error templates
export const HTTP_ERROR_TEMPLATES = {
    HTTP_STATUS_ERROR: (status: number) => `HTTP ${status} Error`,
    HTTP_STATUS: (status: number) => `HTTP ${status}`,
    ERROR_WITH_MESSAGE: (message: string) => `Error: ${message}`,
} as const;

export const HTTP_STATUS_CODES = {
    HTTP_STATUS_ERROR: 400,
    HTTP_STATUS: 200,
} as const;
